<template>
    <div class="step_labels" :class="[classes]">
        <!-- <span
            v-if="stepLabelText"
            class="text-sm text-dark-200 font-light inline-block mr-2"
        >
            {{ stepLabelText }}
        </span> -->
        <app-dropdown>
            <app-dropdown-list :placement="placementpos ? placementpos : 'auto'" :distance="distance">
                <template #dropdownBtn>
                    <slot name="dropdown_btn">
                        <div
                            class="progress_labels"
                            :class="[detailPage ? 'text-center justify-center' : '']"
                            @click="handleClick"
                            ref="dropdowns"
                        >
                            <template v-for="(step, index) in addedLabelArray" :key="index">
                                <app-label :classes="step.color" :text="step.name" />
                            </template>
                            <template v-for="(step, index) in editLabels" :key="index">
                                <app-label :classes="step.color" :text="step.name" />
                            </template>
                            <app-button
                                v-if="addBtn"
                                variant="btn-addLabel"
                                class="mt-[7px] !text-gray-300 text-sm"
                                :class="[
                                    detailPage
                                        ? '!bg-gray-100 !rounded-full !text-gray-300 !px-2.5 !border-gray-200 !border !text-xs !h-4'
                                        : '',
                                ]"
                            >
                                +Add label
                            </app-button>
                        </div>
                    </slot>
                </template>
                <template #content="{ hide }">
                    <ul class="progress_labels_dropdown !p-0">
                        <li class="flex-col !items-start hover:!bg-transparent !p-0">
                            <div class="search_input__group" ref="trigClick">
                                <span class="search_input__icon">
                                    <fa :icon="['fal', 'magnifying-glass']"></fa>
                                </span>
                                <input
                                    type="search"
                                    name="contacts"
                                    class="search_autocomplete__input"
                                    placeholder="Search Labels"
                                    v-model="search"
                                    ref="searchInput"
                                />
                            </div>
                            <!-- <pre>{{ props.data }}</pre> -->
                            <div class="mt-4">
                                <div v-if="filteredLabels.length">
                                    <div
                                        class="w-full mb-4 last-of-type:mb-0 !px-4"
                                        v-for="(step, index) in filteredLabels"
                                        :key="index"
                                    >
                                        <app-checkbox
                                            isFull
                                            name="stepLabels"
                                            :id="step.id + labelId"
                                            :checked="step.isChecked"
                                            :modelValue="step.id"
                                            @update:modelValue="getCheckbox(step.id)"
                                        >
                                            <template #checkboxLabel>
                                                <app-label :classes="step.color" :text="step.name" />
                                            </template>
                                        </app-checkbox>
                                    </div>
                                </div>
                                <div v-else>
                                    <p class="px-4 text-gray-200 text-xs">No labels are added</p>
                                </div>
                            </div>
                        </li>

                        <li
                            class="border-t border-gray-150 mt-3 px-4 pb-4 dark:bg-black-900 !rounded-none dark:border-black-900 flex items-center"
                            :class="isSubmit ? 'hover:!bg-transparent' : ''"
                        >
                            <div
                                class="manage_labels px-2 xs:pl-0 py-2 flex items-center cursor-pointer flex-1 rounded-lg"
                                :class="isSubmit ? 'hover:bg-slate-100' : ''"
                                @click="manageLabels()"
                                v-close-popper
                            >
                                <fa class="text-lg text-gray-300 mr-1 dark:text-dm-white" :icon="['fal', 'cog']"> </fa>
                                <span class="text-dark-100 !font-normal text-sm italic dark:text-dm-white">
                                    Manage labels
                                </span>
                            </div>

                            <div
                                v-if="isSubmit"
                                class="manage_labels px-2 xs:pl-0 py-2 flex items-center cursor-pointer hover:bg-slate-100 flex-1 rounded-lg"
                                @click="() => emit('handleSubmit')"
                                v-close-popper
                            >
                                <fa class="text-lg text-gray-300 mr-1 dark:text-dm-white" :icon="['fal', 'download']">
                                </fa>
                                <span class="text-dark-100 !font-normal text-sm italic dark:text-dm-white">
                                    Submit
                                </span>
                            </div>
                        </li>
                    </ul>
                </template>
            </app-dropdown-list>
        </app-dropdown>
    </div>
</template>

<script setup>
import { computed, onMounted, ref } from "vue";
import AppDropdown from "@/components/dropdown/AppDropdown.vue";
import AppDropdownList from "@/components/dropdown/AppDropdownList.vue";
import AppButton from "../AppButton.vue";
import AppCheckbox from "../forms/AppCheckbox.vue";
import AppLabel from "../AppLabel.vue";

const props = defineProps({
    data: {
        type: Array,
        required: true,
        default: () => [],
    },
    editLabels: {
        type: Array,
        required: false,
        default: () => [],
    },
    stepLabelText: {
        type: String,
        default: "",
    },
    classes: {
        type: String,
        default: "",
    },
    detailPage: {
        type: Boolean,
        default: false,
    },
    labelId: {
        type: String,
        default: "label",
    },
    fromPage: {
        type: String,
        default: "",
    },
    placementpos: {
        type: String,
        default: "auto",
    },
    distance: {
        type: Number,
        default: 0,
    },
    isSubmit: {
        type: Boolean,
        default: false,
    },
    addBtn: {
        type: Boolean,
        default: true,
    },
});

const emit = defineEmits(["manageLabels", "checkLabelValue", "handleClick", "handleSubmit"]);

const search = ref("");
const labelValueArray = ref([]);
const dropdowns = ref(null);
const filteredLabels = computed(() => {
    if (!search.value) {
        return props.data;
    }
    return props.data.filter((item) => item.name.toLowerCase().includes(search.value.toLowerCase()));
});
const addedLabelArray = computed(() => {
    // console.log(props.data)
    return props.data.filter((item) => item.isChecked);
});
const getCheckbox = (value) => {
    let ids = [value];
    // console.log(ids, 'checkbox ids')
    props.data.filter((x) => ids.includes(x.id)).map((x) => (x.isChecked = !x.isChecked));
    labelValueArray.value = props.data
        .filter(function (obj) {
            return obj.isChecked;
        })
        .map(function (obj) {
            return obj;
        });
    //         setTimeout(function() {
    //   debugger;
    // }, 0);
    emit("checkLabelValue", labelValueArray.value);
};
const manageLabels = () => {
    emit("manageLabels", { from: props.fromPage });
};

const handleClick = () => {
    // const dropdownHeights = dropdowns.value.closest('.modal_body').offsetHeight;
    //dropdowns.value.offsetParent.childNodes[1].childNodes[1].style.height = dropdownHeights - 50 + 'px';
    //dropdowns.value.offsetParent.childNodes[1].childNodes[1].children.style.height = dropdownHeights - 50 + 'px';
    // console.log(
    //     dropdowns.value.offsetParent.childNodes[1].childNodes[1]
    // );
    emit("handleClick");
};

onMounted(() => {
    // labelValueArray.value = props.data
    //     .filter(function (obj) {
    //         return obj.isChecked;
    //     })
    //     .map(function (obj) {
    //         return obj;
    //     });
    // emit('checkLabelValue', labelValueArray.value);
});
</script>

<style scoped>
.step_labels {
    @apply flex items-center;
}

.progress_labels {
    @apply flex flex-wrap items-center gap-2;
}

.progress_labels :deep(.app_chips) {
    @apply mb-2;
}
.progress_labels_dropdown .search_autocomplete__input {
    @apply pl-2;
}
.search_input__group {
    @apply w-full h-[49px] flex items-center dark:bg-black-900 dark:rounded overflow-hidden border-b border-gray-150;
}

.search_autocomplete__input {
    @apply p-4 pl-0 w-full h-full outline-none rounded-lg placeholder:text-sm placeholder:text-gray-300 placeholder:font-light dark:bg-black-900 dark:text-dm-white dark:placeholder:text-dm-palegrey;
}

.search_input__icon {
    @apply !text-base text-gray-300 p-4 pr-0  dark:text-dm-white;
}

.search_input__icon svg {
    @apply !text-base;
}
</style>
